export const requiredDate = (value) => {
    return !value || !(value instanceof Date) ? "This field is required" : undefined;
};
//# sourceMappingURL=validations.js.map